import { observable, action, extendObservable, toJS } from 'mobx';
import { Observable, Subject } from './addRxOperators';

import ContactsQueries from './ContactsQueries';
import ContactListItem from './ContactListItem';
import ContactDetails from './ContactDetails';

const localStorage = window.localStorage || {};

class ContactsStore {
  constructor() {
    this.access_token = localStorage.access_token;
    this.token_type = localStorage.token_type;
    this.company_id = localStorage.company_id;

    this.errorMessage$ = new Subject();
    this.errorMessage$
      .do(msg => (this.errorMessage = msg))
      .debounceTime(15000)
      .subscribe(msg => (this.errorMessage = ''));

    this.contactsQueries = new ContactsQueries(this);
    this.fetchError = this.fetchError.bind(this);

    try {
      if (localStorage.lastTen) {
        this.lastTen = JSON.parse(localStorage.lastTen);
        this.contactsList = this.lastTen.map(c =>
          ContactListItem.fromJSON(c._id, c)
        );
        this.lastTen.forEach(
          c => (this.contactDetails[c._id] = ContactDetails.fromJSON(c._id, c))
        );
      }
    } catch (e) {
      console.error(e);
    }
  }

  @observable access_token = null;
  @observable token_type = null;
  @observable company_id = null;
  @observable contactsList = [];
  @observable contactDetails = {};
  @observable filterText = '';
  @observable errorMessage = '';
  @observable requestBusy = false;
  requestTracker = '';

  lastTen = [];

  persistContact(contact) {
    if (!contact._id) return;

    var lastTen = this.lastTen.filter(c => c._id !== contact._id);
    if (lastTen.length > 9) {
      lastTen.length = 9;
    }
    lastTen.unshift(toJS(contact));

    localStorage.lastTen = JSON.stringify(lastTen);

    this.lastTen = lastTen;
  }

  requestStart(id) {
    this.requestTracker += id;
    if (!this.requestBusy) {
      this.requestBusy = true;
    }
  }

  requestDone(id) {
    this.requestTracker = this.requestTracker.replace(new RegExp(id, 'g'), '');
    if (this.requestBusy && !this.requestTracker) {
      this.requestBusy = !!this.requestTracker;
    }
  }

  fetchCompanyId() {
    return this.contactsQueries.fetchCompanyId();
  }

  search(text) {
    this.contactsQueries.search(text);
  }

  fetchContactDetails(subNr) {
    var details$ = this.contactsQueries.fetchContactDetails(subNr);
    var actions$ = this.contactsQueries.fetchActions(subNr);
    var discounts$ = this.contactsQueries.fetchDiscounts(subNr);
    var history$ = this.contactsQueries.fetchHistory(subNr);
    var bonuses$ = this.contactsQueries.fetchBonuses(subNr);

    Observable.zip(
      details$,
      actions$,
      discounts$,
      history$,
      bonuses$,
      action((contact, actions, discounts, history, bonuses) => {
        extendObservable(contact, { actions, discounts, history, bonuses });
        return contact;
      })
    ).subscribe(contact => {
      Object.assign(this.contactDetails[subNr], contact);
      this.persistContact(contact);
    });
  }

  getContactDetails(subNr) {
    if (!this.contactDetails[subNr]) {
      const listItem = this.contactsList.filter(c => c.subNr === subNr).pop();
      const contact = ContactDetails.fromJSON(subNr, {
        subNr,
        acctName: listItem ? listItem.acctName : subNr
      });

      this.contactDetails[subNr] = contact;
    }
    return this.contactDetails[subNr];
  }

  fetchError(err) {
    if (err.status === 401) {
      this.access_token = null;
    } else {
      console.error(err);

      const rsp = err.xhr.response;

      if (rsp && (rsp.ErrorType || rsp.ErrorMessage)) {
        // {"ErrorType":"CommunicationError","ErrorNumbers":null,"ErrorMessage":"Er is geen antwoord ontvangen."}
        this.setErrorMessage(`${rsp.ErrorType}: ${rsp.ErrorMessage}`);
      } else if (err.message) {
        this.setErrorMessage(err.message);
      }
    }
  }

  setErrorMessage(errorMessage = '') {
    this.errorMessage$.next(errorMessage);
  }
}

const contactsStore = new ContactsStore();

export default contactsStore;



// WEBPACK FOOTER //
// ./src/store/contactsStore.js